import React, {useEffect, useState, useCallback} from 'react';
import {useSelector, useDispatch} from 'react-redux';

import DashboardsContainer from './components/DashboardsContainer';
import DateRange from './components/DateRange';
import useDateRange from './hooks/useDateRange';
import {uiTypeMap} from './formBuilder/utils';
import useQuicksightConfiguration from './hooks/useQuicksightConfiguration';
import {setDashboardsDateStart, setDashboardsDateEnd} from './redux/dashboardConfiguration/actions';

import {selectorDate} from './redux/dashboardConfiguration/selectors';


const Quicksight = () => {
    const [uiMap, setuiMap] = useState(undefined);
    const dispatch = useDispatch();

    const dashboardDateStart = useSelector(selectorDate);
    const {startDate, setStartDateCall, endDate, setEndDateCall} = useDateRange(1, dashboardDateStart);

    const existQuicksightConfiguration = useQuicksightConfiguration();

    useEffect(() => {
        setuiMap(uiTypeMap['default']);
    }, []);

    const setStartDateCallStore = useCallback(
        (date) => {
            setStartDateCall(date);
            dispatch(setDashboardsDateStart(date));
        },
        [dispatch, setStartDateCall],
    );

    const setEndDateCallStore = useCallback(
        (date) => {
            setEndDateCall(date);
            dispatch(setDashboardsDateEnd(date));
        },
        [dispatch, setEndDateCall],
    );

    return (
        <div className="container-fluid dashboard">
            <div className="dash-container">
                {uiMap && existQuicksightConfiguration ? (
                    <div>
                        <DashboardsContainer
                            startDate={startDate}
                            endDate={endDate}
                            componentsMapper={uiMap}
                        >
                            <DateRange
                                startDate={startDate}
                                setStartDateCall={setStartDateCallStore}
                                endDate={endDate}
                                setEndDateCall={setEndDateCallStore}
                            />
                        </DashboardsContainer>
                    </div>
                ) : (
                    <div>no dashboards</div>
                )}
            </div>
        </div>
    );
};
export default Quicksight;
